import React, {useMemo} from 'react'
import useQueryLeaderGraph from '../../../../hooks/api/leader/useQueryLeaderGraph'
import ContainerLayout from '../../../../components/layout/ContainerLayout'
import Text from '../../../../components/text/Text'
import TableHeader from '../../../../components/table/TableHeader'
import TableLayout from '../../../../components/table/TableLayout'
import TableItem from '../../../../components/table/TableItem'
import {useDisplayNumber} from '../../../../utils/number'
import LeaderChartMWR from './LeaderChartMWR'
import LeaderChartTWR from './LeaderChartTWR'

interface IProps {
    className?: string
    leaderId?: string
}

const LeaderGraphContainer: React.FC<IProps> = ({className, leaderId}) => {
    const {data} = useQueryLeaderGraph(leaderId)
    const {renderPercent, floorBalance, displayAmount} = useDisplayNumber()
    const renderDate = when => {
        const date = String(when)
        const year = date?.substring(0, 4)
        const month = date?.substring(4, 6)
        const day = date?.substring(6, 8)

        return `${year}.${month}.${day}`
    }

    const graphs = useMemo(() => {
        if (data === undefined) {
            return []
        }
        data.sort((a, b) => {
            if (a.when > b.when) {
                return 1
            }
            return -1
        })
        return data
    }, [data])

    return (
        <ContainerLayout title={'투자 손익 그래프 (TWR, MWR)'} className={className}>
            <article>
                <section>
                    <div className={'mt-[20px] grid grid-cols-2 gap-x-[50px] text-center'}>
                        <LeaderChartMWR data={graphs} />
                        <LeaderChartTWR data={graphs} />
                    </div>
                </section>
                <section className={'mt-[50px]'}>
                    <Text className={'text-ti1'}>투자 손익 상세</Text>
                    <TableHeader className={'mt-[20px] grid grid-cols-7'}>
                        <Text>일자</Text>
                        <Text>손익</Text>
                        <Text>수익률</Text>
                        <Text>기초 자산</Text>
                        <Text>기말 자산</Text>
                        <Text>입금</Text>
                        <Text>출금</Text>
                    </TableHeader>
                    <TableLayout>
                        {data?.map(item => (
                            <>
                                <TableItem className={'grid grid-cols-7'}>
                                    <Text>{renderDate(item?.when)}</Text>
                                    <Text
                                        className={`text-ti2 ${
                                            item?.earning < 0
                                                ? 'text-font_red'
                                                : item?.earning > 0
                                                ? 'text-font_green'
                                                : 'text-font03'
                                        }`}>
                                        {floorBalance(item?.earning, 100, false, '$')}
                                    </Text>
                                    <Text
                                        className={`text-ti2 ${
                                            item?.profit < 0
                                                ? 'text-font_red'
                                                : item?.profit > 0
                                                ? 'text-font_green'
                                                : 'text-font03'
                                        }`}>
                                        {renderPercent(item?.profit, 1000)}
                                    </Text>
                                    <Text>{floorBalance(item?.start_balance, 100, false, '$')}</Text>
                                    <Text>{floorBalance(item?.end_balance, 100, false, '$')}</Text>
                                    <Text
                                        className={`text-ti2 ${item?.deposit > 0 ? 'text-font_green' : 'text-font03'}`}>
                                        {floorBalance(item?.deposit, 100, false, '$')}
                                    </Text>
                                    <Text
                                        className={`text-ti2 ${item?.withdraw > 0 ? 'text-font_red' : 'text-font03'}`}>
                                        {floorBalance(item?.withdraw, 100, false, '$')}
                                    </Text>
                                </TableItem>
                            </>
                        ))}
                    </TableLayout>
                </section>
            </article>
        </ContainerLayout>
    )
}

export default LeaderGraphContainer
